<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-row>
        <!-- Inicio Panel FILTRO -->
        <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
          <vs-card>
            <div slot="header">
              <h3 class="card-title mb-0">Información de filtro</h3>
            </div>
            <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
            <vs-row>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <!-- Selector de empresa -->
                <company-selector v-model="companyId"/>
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">Fecha de inicio</label>
                <vs-input type="date" v-model="initialDate" class="w-100 "/>
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">Fecha de fin</label>
                <vs-input type="date" v-model="finalDate" class="w-100 "/>
              </vs-col>
            </vs-row>
            <br/>
            <vs-row>
              <!-- Selector de tipo de servicio -->
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">Tipo de Servicio</label>
                <vs-select class="w-100" v-model="frequencyType" placeholder="Seleccione un servicio">
                  <vs-select-item :key="index" :value="item.value" :text="item.text"
                                  v-for="(item, index) in type_service"/>
                </vs-select>
              </vs-col>
            </vs-row>
            <hr class="custom-hr"/>
            <div class="d-inline-block d-md-flex align-items-center">
              <div class="btn-alignment">
                <vs-button @click="listPreview()">Buscar</vs-button>
                <vs-button color="gray" @click="clearForm()">Limpiar</vs-button>
              </div>
              <div class="ml-auto mt-3 mt-md-0">
                <div class="d-flex align-items-center">
                  <div class="d-flex align-items-center dropdownbtn-alignment ml-3">
                    <vs-button class="btnx" type="filled" color="danger" @click="donwloadReport()">
                      <i class="ti-upload mr-2"></i>Exportar
                    </vs-button>

                    <vs-dropdown>
                      <vs-button class="btn-drop" type="filled" color="danger" icon="expand_more"></vs-button>
                      <vs-dropdown-menu>
                        <vs-button class="dropdown-item" color="'default'" v-for="document in documents"
                                   :value="document.id" :key="document.id"
                                   :id="document.id" @click="formatType=document.id">{{ document.name }}
                        </vs-button>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </vs-card>
        </vs-col>
        <!-- Inicio Panel linea de tiempo -->
        <vs-col vs-lg="12" vs-xs="12" v-if="frequencyType">
          <!-- Linea de tiempo -->
          <vs-card>
            <h3 class="card-title d-flex">
              Linea Frecuencia de uso casilleros

            </h3>
            <div>
              <vue-apex-charts type="bar" height="350" :options="this.lineAreaChartSplineLocker.chartOptions"
                               :series="this.lineAreaChartSplineLocker.series">
              </vue-apex-charts>
            </div>
          </vs-card>
          <div>
          </div>
        </vs-col>
        <!-- Fin Panel linea de tiempo -->

        <!-- Inicio Panel linea de tiempo -->
        <vs-col vs-lg="12" vs-xs="12" v-if="!frequencyType">
          <!-- Linea de tiempo -->
          <vs-card>
            <h3 class="card-title d-flex">
              Linea Frecuencia de Ingreso Cicloparqueadero

            </h3>
            <div>
              <vue-apex-charts type="bar" height="350" :options="this.lineAreaChartSplinePark.chartOptions"
                               :series="this.lineAreaChartSplinePark.series">
              </vue-apex-charts>
            </div>
          </vs-card>
          <div>
          </div>
        </vs-col>
        <!-- Fin Panel linea de tiempo -->


        <vs-col vs-lg="12" vs-xs="12" v-if="!frequencyType">
          <vs-card>
            <h3 class="card-title d-flex">
              Tabla ingreso cicloparqueadero
            </h3>
            <div class="border">
              <vs-table max-items="20" pagination :data="tableData">
                <template slot="thead">
                  <vs-th>Fecha</vs-th>
                  <vs-th>V.I.P bicicletas</vs-th>
                  <vs-th>Mensuales bicicletas</vs-th>
                  <vs-th>Rotación bicicletas</vs-th>
                  <vs-th>Tarjeta perdida bicicletas</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr,indextr) in data">
                    <vs-td :data="data[indextr].days">
                      {{ data[indextr].days }}
                    </vs-td>
                    <vs-td :data="data[indextr].vipBike">
                      {{ data[indextr].vipBike }}
                    </vs-td>
                    <vs-td :data="data[indextr].monthlyBike">
                      {{ data[indextr].monthlyBike }}
                    </vs-td>
                    <vs-td :data="data[indextr].rotationBike">
                      {{ data[indextr].rotationBike }}
                    </vs-td>
                    <vs-td :data="data[indextr].lostBike">
                      {{ data[indextr].lostBike }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vs-card>
          <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
            <vs-card>
              <h3 class="card-title d-flex">
                Totales de la busqueda
              </h3>
              <div class="table-responsive border">
                <table class="table v-middle border">
                  <thead>
                  <tr>
                    <th class=" border-top-0">
                      VIP Bicicletas
                    </th>
                    <th class=" border-top-0">
                      Mensuales Bicicletas
                    </th>
                    <th class=" border-top-0">
                      Rotación bicicletas
                    </th>
                    <th class=" border-top-0">
                      Tarjetas perdidas
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td class="text-center">
                      <div class="d-flex align-items-center">
                        <div class="mr-2">
                          <h5 class="m-b-0 text-center">

                            {{ totalsPreviewPark.vipBike }}
                          </h5>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex align-items-center">
                        <div class="mr-2">
                          <h5 class="m-b-0 text-center">
                            {{ totalsPreviewPark.monthlyBike }}
                          </h5>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex align-items-center">
                        <div class="mr-2">
                          <h5 class="m-b-0 text-center">
                            {{ totalsPreviewPark.rotationBike }}
                          </h5>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex align-items-center">
                        <div class="mr-2">
                          <h5 class="m-b-0 text-center">
                            {{ totalsPreviewPark.lostBike }}
                          </h5>
                        </div>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </vs-card>
          </vs-col>
          <!-- Fin de tabla de datos -->
        </vs-col>
        <vs-col vs-lg="12" vs-xs="12" v-if="frequencyType">
          <vs-card>
            <h3 class="card-title d-flex">
              Tabla de frecuencia de uso casilleros
            </h3>
            <div class="border" style="max-height: 43em;
              overflow-y: auto;">
              <vs-table max-items="20" pagination :data="tableData">
                <template slot="thead">
                  <vs-th>Fecha</vs-th>
                  <vs-th>Rotación moto</vs-th>
                  <vs-th>Rotación bicicleta</vs-th>
                  <vs-th>Mensuales bicicleta</vs-th>
                  <vs-th>Mensuales motos</vs-th>
                  <vs-th>Perdida de QR</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr,indextr) in data">
                    <vs-td :data="data[indextr].days">
                      {{ data[indextr].days }}
                    </vs-td>
                    <vs-td :data="data[indextr].lockerRotation">
                      {{ data[indextr].lockerRotation }}
                    </vs-td>
                    <vs-td :data="data[indextr].lockerRotationBike">
                      {{ data[indextr].lockerRotationBike }}
                    </vs-td>
                    <vs-td :data="data[indextr].lockerMonthlyBike">
                      {{ data[indextr].lockerMonthlyBike }}
                    </vs-td>
                    <vs-td :data="data[indextr].lockerMonthly">
                      {{ data[indextr].lockerMonthly }}
                    </vs-td>
                    <vs-td :data="data[indextr].lostLocker">
                      {{ data[indextr].lostLocker }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vs-card>
          <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
            <vs-card>
              <h3 class="card-title d-flex">
                Totales de la busqueda
              </h3>
              <div class="table-responsive border">
                <table class="table v-middle border">
                  <thead>
                  <tr>
                    <th class="border-top-0">
                      Rotación moto
                    </th>
                    <th class="border-top-0">
                      Rotación bicicleta
                    </th>
                    <th class=" border-top-0">
                      Mensual moto
                    </th>
                    <th class="border-top-0">
                      Mensuales bicicleta
                    </th>
                    <th class=" border-top-0">
                      Perdidas de QR
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td class="text-center">
                      <div class="d-flex align-items-center">
                        <div class="mr-2">
                          <h5 class="m-b-0 text-center">
                            {{ totalsPreviewLocker.lockerRotation }}
                          </h5>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex align-items-center">
                        <div class="mr-2">
                          <h5 class="m-b-0 text-center">
                            {{ totalsPreviewLocker.lockerRotationBike }}
                          </h5>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex align-items-center">
                        <div class="mr-2">
                          <h5 class="m-b-0 text-center">
                            {{ totalsPreviewLocker.lockerMonthly }}
                          </h5>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex align-items-center">
                        <div class="mr-2">
                          <h5 class="m-b-0 text-center">
                            {{ totalsPreviewLocker.lockerMonthlyBike }}
                          </h5>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex align-items-center text-center">
                        <div class="mr-2 text-center">
                          <h5 class="m-b-0 text-center">
                            {{ totalsPreviewLocker.lostLocker }}
                          </h5>
                        </div>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </vs-card>
          </vs-col>
        </vs-col>
      </vs-row>
    </vs-col>
  </vs-row>
</template>

<script>
import CompanySelector from "@/components/Shared/CompanySelector";
import Multiselect from "vue-multiselect";
import DateUtils from "@/global/DateUtils";
import centroMayorEndpoint from "@/endpoints/reports/centro-mayor/centroMayorEndpoint";
import {ROUTES} from "@/global/api_routes";
import {configToast, TOAST_TYPES} from "@/global/toast";
import VueApexCharts from "vue-apexcharts";


export default {
  components: {
    CompanySelector,
    Multiselect,
    VueApexCharts,
  },
  data() {
    return {
      lockerMax: 0,
      parkMax: 0,
      type_service: [
        {text: "Cicloparqueadero", value: false},
        {text: "Casillero", value: true},
      ],
      initialDate: null,
      finalDate: null,
      companyId: null,
      formatType: "xlsx",
      documents: [
        {name: ".xlsx", id: "xlsx"},
      ],
      frequencyType: true,
      isLoading: false,
      originalData: [],
      tableData: [],
      forPageElements: 20,
      lineAreaChartSplinePark: {
        series: [{
          name: 'Cantidad de registros',
          data: [0, 0, 0, 0]
        }],
        chartOptions: {
          dataLabels: {
            enabled: true,
            position: 'top',
          },
          stroke: {
            curve: 'smooth'
          },
          colors: ['#4fc3f7', '#2962FF', '#f62d51', '#ffbc34', '#212529'],
          xaxis: {
            type: 'String',
            categories: ["Mensual Vip", "Mensual", "Rotación bicicleta",
              "Tarjeta Perdida"
            ],
          },
          yaxis: {
            min: 0,
            max: this.parkMax
          },
          tooltip: {
            x: {
              format: 'dd/MM/yy HH:mm'
            },

          },
          chart: {
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              export: {
                csv: {
                  filename: 'Frecuencia de ingreso cicloparqueadero',
                  columnDelimiter: ',',
                  headerCategory: 'category',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  }
                },
                svg: {
                  filename: 'Frecuencia de ingreso cicloparqueadero'
                },
                png: {
                  filename: 'Frecuencia de ingreso cicloparqueadero'
                },
                formatter: function (title) {
                  return title.replace('{%initialDate%}', this.initialDate).replace('{%finalDate%}', this.finalDate);
                }
              },
              autoSelected: 'zoom'
            },
          }
        }
      },
      lineAreaChartSplineLocker: {
        series: [
          {
            name: 'Cantidad de registros',
            data: [0, 0, 0, 0, 0]
          }
        ],
        chartOptions: {
          dataLabels: {
            enabled: true,
            position: 'top',
          },
          stroke: {
            curve: 'smooth'
          },
          colors: ['#4fc3f7', '#2962FF', '#f62d51', '#ffbc34', '#212529'],
          xaxis: {
            type: 'String',
            categories: ["Caillero Moto", "Caillero Bicicleta", "Mensual Bicicleta",
              "Mensual Moto", "QR Perdido"
            ],
          },
          yaxis: {
            min: 0,
            max: this.lockerMax
          },
          tooltip: {
            x: {
              format: 'dd/MM/yy HH:mm'
            },
          },
          chart: {
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              export: {
                csv: {
                  filename: 'Frecuencia de ingreso lockers',
                  columnDelimiter: ',',
                  headerCategory: 'category',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  }
                },
                svg: {
                  filename: 'Frecuencia de ingreso lockers'
                },
                png: {
                  filename: 'Frecuencia de ingreso lockers'
                },
                formatter: function (title) {
                  return title.replace('{%initialDate%}', this.initialDate).replace('{%finalDate%}', this.finalDate);
                }
              },
              autoSelected: 'zoom'
            },
          }

        }
      },
      totalsPreviewLocker: {},
      totalsPreviewPark: {},
    }
  },
  mounted() {
    this.updateChartDates();
  },
  watch: {
    frequencyType() {
      this.tableData = [];
      this.totalsPreviewPark = {};
      this.totalsPreviewLocker = {};
      this.graphicInitialize();
    },
    initialDate() {
      this.tableData = [];
      this.totalsPreviewPark = {};
      this.totalsPreviewLocker = {}
      this.graphicInitialize();
    },
    finalDate() {
      this.tableData = [];
      this.totalsPreviewPark = {};
      this.totalsPreviewLocker = {}
      this.updateChartDates();
      this.graphicInitialize();
    }

  },
  methods: {
    /**
     * metodo para mostrar las alertas de las validaciones
     * @param message
     * @param type
     */
    toast(message, type = TOAST_TYPES.INFO) {
      const instance = configToast(this, "#invoices_reports");
      return instance.open(message, type);
    },
    /**
     * Método que limpia el formulario inicial y la tabla
     */
    clearForm() {
      this.companyId = null;
      this.initialDate = null;
      this.finalDate = null;
      this.formatType = null;
      this.frequencyType = null;
      this.lineAreaChartSplinePark.series = [{
        name: 'Cantidad de registros',
        data: [0, 0, 0, 0]
      }];
      this.lineAreaChartSplineLocker.series = [{
        name: 'Cantidad de registros',
        data: [0, 0, 0, 0, 0]
      }];
      this.lockerMax = 0;
      this.parkMax = 0;
      this.totalsPreviewPark = {};
      this.totalsPreviewLocker = {};
    },
    /**
     * Método que hace la asignación de mis parametros de busqueda con los elemetos del formulario
     * @returns {{finalDate: string, companyId: null, frecuencyType: null, type: null, initialDate: string}}
     * retorna  mis parametros listos para hacer la petición
     */
    prepareParameters() {
      return {
        companyId: this.companyId,
        initialDate: DateUtils.toDateShortString({
          date: this.initialDate,
        }),
        finalDate: DateUtils.toDateShortString({
          date: this.finalDate,
        }),
        frecuencyType: this.frequencyType
      }
    },
    /**
     *
     * @returns {Promise<void>}
     */
    async validateForm() { // metodo que valida mis parametros en la interfaz grafica
      //para no hecer peticiones erroneas al servidor
      if (!this.finalDate || !this.initialDate) {
        throw new Error("Debe seleccionar fecha inicial y/o fecha final");
      }
      const validationResult = await this.$validator.validateAll();
      const validDates = DateUtils.isBefore({
        before: this.finalDate,
        date: this.initialDate,
      });
      if (validDates) {
        throw new Error("Fecha final no puede ser inferior a fecha inicial");
      }
      if (!validationResult) {
        throw new Error("Complete el formulario");
      }
      if (!this.companyId) {
        throw new Error("Seleccione una compañia");
      }
      if (this.frequencyType === null) {
        throw new Error("Seleccione un tipo de servicio");
      }
    },
    /**
     * metodo que gestiena la descarga del reporte
     * @returns {Promise<void>}
     */
    async donwloadReport() {
      try {
        await this.validateForm();
        this.isLoading = true;
        const objParams = this.prepareParameters();
        centroMayorEndpoint.download(objParams)
            .then(data => {
              if (data.code < 0) {
                this.isLoading = false;
                return;
              }
              this.isLoading = false;
              let a = document.createElement("a");
              const urlFile =
                  process.env.VUE_APP_URL + ROUTES.GLOBAL.DOWNLOAD_FILE + data.info;
              a.href = urlFile;
              document.body.appendChild(a);
              console.log(urlFile);
              a.download = urlFile;
              a.click();
            })
      } catch (error) {
        this.toast(error.message, TOAST_TYPES.ERROR);
      }
    },
    /**
     * metodo que llama la promesa para el rest de listar la informacion
     * @returns {Promise<void>}
     */
    async listPreview() {
      try {
        await this.validateForm();
        this.isLoading = true;
        const objAccess = this.prepareParameters();
        centroMayorEndpoint.listFrequency(objAccess)
            .then(data => {
              if (data.info === null) {
                this.tableData = [];
                this.isLoading = false;
                return;
              }
              this.isLoading = false;
              this.tableData = data.info;
              this.calculateTotalAmounts(data.info);
            });
      } catch (error) {
        this.toast(error.message, TOAST_TYPES.ERROR);
      }
    },
    /**
     * metodo que calcula los los totales de la informacion de la lista por cada item de la lista
     * @param list
     * @returns {{}}
     */
    calculateTotalAmounts(list) {
      const totals = {};
      list
          .forEach(value => {
            for (const property in value) {
              if (value.hasOwnProperty(property)) {
                if (typeof totals[property] === 'undefined') {
                  totals[property] = Number(value[property]) || 0;
                } else {
                  totals[property] += Number(value[property]) || 0;
                }
              }
            }
          });
      this.separeDataGraphic(totals);
      return totals;
    },
    /**
     * metodo que separa la informacion de la frecuencia y la envia al grafico correspondiente
     * @param obj objeto con la informacion
     */
    separeDataGraphic(obj) {
      delete obj.days;
      const objLocker = {};
      const objPark = {};
      for (const property in obj) {
        if (property.includes('ocker')) {
          objLocker[property] = obj[property];
        } else {
          objPark[property] = obj[property];
        }
      }
      this.lineAreaChartSplinePark.series = [{
        name: 'Cantidad de registros',
        data: Object.values(objPark)
      }];
      this.parkMax = this.getMaxValueArray(Object.values(objPark));

      this.lineAreaChartSplineLocker.series = [{
        name: 'Cantidad de registros',
        data: Object.values(objLocker)
      }];
      this.lockerMax = this.getMaxValueArray(Object.values(objLocker));
      this.totalsPreviewLocker = objLocker;
      this.totalsPreviewPark = objPark;
    },
    /**
     * Metodo que me devuele el valor maximo del array para fijar la escala de la grafica
     * @param array
     * @returns {number}
     */
    getMaxValueArray(array) {
      return parseInt(Math.max(...array));
    },
    /**
     * metodo para editar en nombre del el archivo al darle descargar al grafico
     */
    updateChartDates() {
      if (!this.finalDate || !this.initialDate) {
        return;
      }
      const stringInitial = DateUtils.toDateShortString({date: this.initialDate})
      const stringFinal = DateUtils.toDateShortString({date: this.finalDate})
      this.lineAreaChartSplineLocker.chartOptions.chart.toolbar.export.csv.filename =
          'Frecuencia de ingreso lockers' + stringInitial + ' a' + stringFinal
      this.lineAreaChartSplineLocker.chartOptions.chart.toolbar.export.png.filename =
          'Frecuencia de ingreso lockers' + stringInitial + ' a' + stringFinal
      this.lineAreaChartSplineLocker.chartOptions.chart.toolbar.export.svg.filename =
          'Frecuencia de ingreso lockers' + stringInitial + ' a' + stringFinal
      this.lineAreaChartSplinePark.chartOptions.chart.toolbar.export.csv.filename =
          'Frecuencia de ingreso cicloparqueadero' + stringInitial + ' a' + stringFinal
      this.lineAreaChartSplinePark.chartOptions.chart.toolbar.export.png.filename =
          'Frecuencia de ingreso cicloparqueadero' + stringInitial + ' a' + stringFinal
      this.lineAreaChartSplinePark.chartOptions.chart.toolbar.export.svg.filename =
          'Frecuencia de ingreso cicloparqueadero' + stringInitial + ' a' + stringFinal
    },
    /**
     * setea los valores de la grafica a cero
     */
    graphicInitialize() {
      this.lineAreaChartSplinePark.series = [{
        name: 'Cantidad de registros',
        data: [0, 0, 0, 0]
      }];
      this.lineAreaChartSplineLocker.series = [{
        name: 'Cantidad de registros',
        data: [0, 0, 0, 0, 0]
      }];
      this.lockerMax = 0;
      this.parkMax = 0;
    }
  },
}
</script>
